/* istanbul ignore file */
import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";
import { ILocalizable, ILocale } from "infrastructure/localization";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";
import { IIndustry } from "ui/shared/models/common";

import { ITermTranslationRelationship, ITermTranslationModel } from "./TranslationsManager.state";

export interface ITermTranslationsGetRequest {
  locale?: string;
  industry?: string;
  translationSource?: string;
  translationStatus?: string;
  textFilter?: string;
}

export interface ITermTranslationsApproveRequest {
  translationId: string;
  termId: string;
  locale: string;
  industry?: string;
  version: number;
}

const getApiProvider = () => {
  return {
    getIndustries: async (filter?: string) => {
      const response = await getClientFor(mainApi.name).get<IIndustry[]>("/industries", { params: { filter: filter ? filter : undefined } });
      return response.data;
    },
    getLocales: async (filter?: string) => {
      const response = await getClientFor(mainApi.name).get<ILocale[]>("/locales", { params: { filter: filter ? filter : undefined } });
      return response.data;
    },
    getTranslationSources: () => {
      const sources: ILocalizable[] = [{ messageId: glossaryMessages.option("termTranslationSourcePlex") }, { messageId: glossaryMessages.option("termTranslationSourceMachine") }];
      return sources;
    },
    getTranslationStatuses: () => {
      const statuses: ILocalizable[] = [
        { messageId: glossaryMessages.option("termTranslationStatusInReview") },
        { messageId: glossaryMessages.option("termTranslationStatusApproved") }
      ];
      return statuses;
    },
    getTermTranslations: async (parameters: ITermTranslationsGetRequest) => {
      const params = {
        locale: parameters.locale,
        industry: parameters.industry,
        source: parameters.translationSource,
        status: parameters.translationStatus,
        textFilter: parameters.textFilter
      };

      const response = await getClientFor(mainApi.name).get<ITermTranslationRelationship[]>("/term-translations/search", { params });

      return response.data;
    },
    saveTermTranslations: async (translations: ITermTranslationModel[]) => {
      const response = await getClientFor(mainApi.name).post("/term-translations", translations);
      return response.data;
    },
    approveTermTranslations: async (request: ITermTranslationsApproveRequest[]) => {
      const response = await getClientFor(mainApi.name).post("/term-translations/approve", request);
      return response.data;
    },
    exportTermTranslationsToXml: async (parameters: ITermTranslationsGetRequest) => {
      const params = {
        locale: parameters.locale,
        industry: parameters.industry,
        source: parameters.translationSource,
        status: parameters.translationStatus,
        textFilter: parameters.textFilter
      };

      await getClientFor(mainApi.name).get("/term-translations/export", { params, responseType: "blob" });
    },
    downloadTermTranslationsUploadTemplate: async () => {
      await getClientFor(mainApi.name).get("/term-translations/template", { responseType: "blob" });
    }
  };
};

export const translationsManagerApi = getApiProvider();
